import brittanymurphy from "../../../image/originals/hollywoodicons/brittanymurphy.webp"; 
import ItemNoSize from "../ItemNoSize";

const Shop = () => {
  const items = [
    {
      id: "85_base",
      name: "Brittany Murphy Print",
      image: brittanymurphy, // Main image without .webp
      price: "empty for now",
      thumbnails: [brittanymurphy], // Other images (if available)
      description: 'Roughly 20" x 20" Museum Rag Paper.',
      projectUrl: "/BrittanyMurphyPrint",
      sizes: ["blank"],
    },
  ];

  return <ItemNoSize items={items} />;
};

export default Shop;
